module.exports = __webpack_public_path__ + "img/palm2_5.056171ed.png";